<template>
  <div>
    <v-card class="elevation-0">
      <v-layout mr-2 justify-space-between>
        <v-flex xs12 sm8 md3>
          <page-title title="Summary" />
        </v-flex>
        <v-flex xs12 sm8 md3 mt-4>
          <v-select
            :items="timePeriods"
            v-model="selectedTimePeriod"
            return-object
            background-color="white"
            label="Time Period"
            dense
            outlined
            @change="getStats"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap pb-4 pl-2 pr-2>
        <stat
          v-for="(stat, index) in statCards"
          :key="index"
          :stat="stat"
          :prefix="selectedTimePeriod.prefix"
        />
      </v-layout>
    </v-card>
    <v-layout wrap mt-6>
      <stat-card
        title="Pending Orders"
        subtitle="Orders that have not been submitted to distributors for fulfillment"
      >
        <pending-orders :orders="pendingOrders" />
      </stat-card>
      <stat-card title="Pending Users" subtitle="Users who have not completed their registration">
        <pending-users :users="pendingUsers" />
      </stat-card>
      <stat-card title="Orders by Status" subtitle="Breakdown of orders based on status">
        <order-breakdown-chart
          :pending="pending"
          :confirmed="confirmed"
          :submitted="submitted"
          :completed="completed"
        />
      </stat-card>
    </v-layout>
  </div>
</template>

<script>
import StatsService from "@/services/stats/stats.service";
import StatCard from "@/components/shared/stats/StatCard";
import PendingOrders from "@/components/shared/stats/PendingOrders";
import PendingUsers from "@/components/shared/stats/PendingUsers";
import Stat from "@/components/shared/stats/Stat";
import PageTitle from "@/components/shared/PageTitle";
import OrderBreakdownChart from "@/components/shared/stats/OrderBreakdownChart";

export default {
  name: "StatsContainer",
  props: {
    color: {
      type: String,
      default: "primary",
    },
    icon: {
      type: String,
      default: "delete",
    },
    title: {
      type: String,
      default: "Some title",
    },
  },
  components: {
    StatCard,
    Stat,
    PendingOrders,
    PendingUsers,
    PageTitle,
    OrderBreakdownChart,
  },
  async mounted() {
    await this.getStats();
  },
  data() {
    return {
      timePeriods: [
        {
          text: "Today",
          value: "today",
          prefix: "Today's",
        },
        // {
        //   text: "This Week",
        //   value: "thisWeek",
        //   prefix: "This Week's",
        // },
        {
          text: "This Month",
          value: "thisMonth",
          prefix: "This Month's",
        },
        {
          text: "This Year",
          value: "thisYear",
          prefix: "This Year's",
        },
      ],
      selectedTimePeriod: {
        value: "thisYear",
        prefix: "This Year's",
      },
      statCards: [],
      statsService: new StatsService(),
      pendingOrders: [],
      pendingUsers: [],
      donut: {},
      pending: 0,
      submitted: 0,
      confirmed: 0,
      completed: 0,
      totalOrders: 0,
    };
  },
  methods: {
    async getStats() {
      const stats = await this.statsService.getAssociateStats(
        this.selectedTimePeriod
      );
      const {
        pendingOrders,
        pendingUsers,
        statCards,
        pending,
        submitted,
        confirmed,
        completed,
      } = stats;

      Object.assign(this, {
        pendingOrders,
        pendingUsers,
        statCards,
        pending,
        submitted,
        confirmed,
        completed,
        totalOrders: pending + submitted + confirmed + completed,
      });
    },
  },
};
</script>
